import { Image } from "antd";
import one from "../assets/img/gallery-dimaond/one.webp";
import two from "../assets/img/gallery-dimaond/two.webp";
import three from "../assets/img/gallery-dimaond/three.webp";
import four from "../assets/img/gallery-dimaond/four.webp";
import five from "../assets/img/gallery-dimaond/five.webp";
import six from "../assets/img/gallery-dimaond/six.webp";
import seven from "../assets/img/gallery-dimaond/seven.webp";
import eight from "../assets/img/gallery-dimaond/eight.webp";

import { Container } from "react-bootstrap";
const Gallery = () => (
  <section className="section-spacing-x mt-lg-5 gallery-section">
    <Container fluid>
      <Image.PreviewGroup
        preview={{
          onChange: (current, prev) =>
            console.log(`current index: ${current}, prev index: ${prev}`),
        }}
      >
        <div className="row">
          <div className="col-l2 gallery-section">
            <h2 className="heading mb-3 text-center">Our Store</h2>
            <p className=" gallery-section-para text-lg-center">
              Experience our interior design expertise in person at our stores.
              Explore materials, finishes, furniture samples, and design
              displays to get inspired. Our team is available on-site to guide
              you through your choices and help plan your dream space. Walk in
              or book a visit today!
            </p>
          </div>
          <div className="col-lg-3 col-6 mb-4">
            {/* <Image
              width={200}
              src="https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg"
            /> */}
            <Image
              src={one}
              alt="best diamond certification in india | Best Diamond Lab in India | Sreehari Diamond Laboratory "
            />
          </div>
          <div className="col-lg-3 col-6  mb-4">
            <Image
              src={two}
              alt="Diamond Bangles verification | Best Diamond Lab in India | Sreehari Diamond Laboratory "
            />
          </div>
          <div className="col-lg-3 col-6  mb-4">
            <Image
              src={three}
              alt="Diamond Earing Verification | Best Diamond Lab in India | Sreehari Diamond Laboratory "
            />
          </div>
          <div className="col-lg-3 col-6  mb-4">
            <Image
              src={four}
              alt="Diamond Necklace Verification | Best Diamond Lab in India | Sreehari Diamond Laboratory "
            />
          </div>
          <div className="col-lg-3 col-6  mb-4">
            <Image
              src={five}
              alt="Diamond Necklace Verification | Best Diamond Lab in India | Sreehari Diamond Laboratory "
            />
          </div>
          <div className="col-lg-3 col-6  mb-4">
            <Image
              src={six}
              alt="Diamond Necklace Verification | Best Diamond Lab in India | Sreehari Diamond Laboratory "
            />
          </div>
          <div className="col-lg-3 col-6  mb-4">
            <Image
              src={seven}
              alt="Diamond Necklace Verification | Best Diamond Lab in India | Sreehari Diamond Laboratory "
            />
          </div>
          <div className="col-lg-3  col-6 mb-4">
            <Image
              src={eight}
              alt="Diamond Necklace Verification | Best Diamond Lab in India | Sreehari Diamond Laboratory "
            />
          </div>
        </div>
      </Image.PreviewGroup>
    </Container>
  </section>
);

export default Gallery;
